// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#sendmessage-group-register[data-v-91fe2700]{max-width:740px;margin-left:auto;margin-right:auto}#sendmessage-group-register .cancel-btn[data-v-91fe2700],#sendmessage-group-register .register-btn[data-v-91fe2700]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
